<div class="help-page px-1r" cdkTrapFocus cdkTrapFocusAutoCapture="true">
  @if (!openPage$()?.selectedPageOpen) {
    <app-menu-controls
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="'help-page.a11y.help-menu-title' | translate"
      (exit)="exit.emit()"
    >
    </app-menu-controls>
  } @else {
    @if (openPage$()?.contactPageOpen) {
      <app-contact [empSpecificContents]="empSpecificContents"> </app-contact>
    }
    @if (openPage$()?.imprintOpen) {
      <app-imprint [empSpecificContents]="empSpecificContents"> </app-imprint>
    }
    @if (openPage$()?.termsOpen) {
      <app-terms [empSpecificContents]="empSpecificContents"> </app-terms>
    }
    @if (openPage$()?.helpOpen) {
      <app-help-details [empSpecificContents]="empSpecificContents"> </app-help-details>
    }
    @if (openPage$()?.sfChatPageOpen) {
      <app-sf-chat-page class="mx--1r"></app-sf-chat-page>
    }
  }
</div>
